module.exports = __webpack_public_path__ + "media/ocean-preview.c2e369fd.mp4";